import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home, LoginRegister, PasswordReset, ResetPasswordConfirm, ChangePassword, Resources, SiteMap, TermsConditions, Form, CheckResults } from "./pages/AllPages";
import { AuthProvider } from './contexts/AuthContext';
import GovBar from "./components/GovBar";
import InstitutionalMenu from "./components/InstitutionalMenu";
import Header from "./components/Header";
import AccessibilityBar from "./components/AccessibilityBar";
import NotFound from './components/NotFound';
import Footer from "./components/Footer";

function App() {
  return (
    <AuthProvider>
      <>
        <a
          href="#contenido-principal"
          className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[2000] focus:bg-cobalt focus:text-white focus:px-4 focus:py-2 focus:rounded focus:font-semibold focus:shadow-lg"
        >
          Saltar al contenido principal
        </a>
        <GovBar />
        <Header />
        <InstitutionalMenu />
        <AccessibilityBar />
        <main id="contenido-principal" tabIndex={-1} className="focus:outline-none">
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/login' element={<LoginRegister />} />
          <Route path='/forgot-password' element={<PasswordReset />} />
          <Route path='/reset-password/:uid/:token' element={<ResetPasswordConfirm />} />
          <Route path='/change-password' element={<ChangePassword />} />
          <Route path='/diagnosticos' element={<Form />} />
          <Route path='/resultados' element={<CheckResults />} />
          <Route path='/recursos' element={<Resources />} />
          <Route path='/mapa-del-sitio' element={<SiteMap />} />
          <Route path='/terminos-y-condiciones' element={<TermsConditions />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
        </main>
        <Footer />
        <div id="popup-root"></div> {/* Contenedor para los popups */}
      </>
    </AuthProvider>
  );
}

export default App;